<template>
	<div class="gb-page">
		<HeadNav selectedLanguage="en" page="privacy-policy" />

		<article class="gb-legal">
			<hh1>Privacy Policy</hh1>
			<p>
				At
				<a class="jump-url" href="https://gbappss.co/">gbappss.co</a>,
				we respect your privacy and are committed to protecting the information you provide when visiting our
				website.
			</p>
			<p>
				This Privacy Policy explains what information we collect, how we use it, and how we protect your
				information while you browse GB Apps.
			</p>

			<hh2>Information We Collect</hh2>
			<p>We may collect limited information automatically when you visit our website, including:</p>
			<ul>
				<li>Browser type</li>
				<li>Device information</li>
				<li>Pages visited</li>
				<li>Website usage data</li>
				<li>IP address information</li>
			</ul>
			<p>This information helps us improve website performance and user experience.</p>

			<hh2>Cookies</hh2>
			<p>
				GB Apps may use cookies to improve website functionality and understand how visitors interact with our
				content.
			</p>
			<p>Cookies may help us:</p>
			<ul>
				<li>Remember user preferences</li>
				<li>Analyze website traffic</li>
				<li>Improve page performance</li>
			</ul>
			<p>You can disable cookies through your browser settings if you prefer.</p>

			<hh2>Third-Party Services</hh2>
			<p>
				We may use third-party services such as analytics tools or advertising partners. These services may
				collect information according to their own privacy policies.
			</p>

			<hh2>Data Protection</hh2>
			<p>
				We take reasonable steps to protect user information. However, no online service can guarantee complete
				security.
			</p>
			<p>By using GB Apps, you agree to the terms described in this Privacy Policy.</p>
		</article>
	</div>
</template>

<script>
import '@/css/base.scss'
import '@/css/index.scss'
import '@/css/gbappss.scss'
import HeadNav from '@/components/HeadNav.vue'

export default {
	name: 'PrivacyPolicy',
	components: { HeadNav },
}
</script>
